<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Contract"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="page--v2 d-flex flex-column"
    v-if="loaded"
  >
    <MaterialTabs
      :tabManager="tabManager"
    >
      <ItpBox
        alignItems="center"
        class="mr-3"
        slot="tabs-start"
      >
        <b-breadcrumb
          class="m-0 bg-white"
        >
          <b-breadcrumb-item
            :text="'Contracts'|gettext"
            :to="b_2285343489561581_to"
          >
          </b-breadcrumb-item>
          <b-breadcrumb-item
            :text="item.snapshot('contract_number')"
            active
          >
          </b-breadcrumb-item>
        </b-breadcrumb>
        <ItpButton
          variant="light"
          icon="fa-sync-alt"
          :tooltip="'Reload'|gettext"
          :spinning="actions.reload.isRunning"
          size="sm"
          class="mr-2"
          @click.prevent.stop="evh_2095089031469157_clickPreventStop($event, {})"
        >
        </ItpButton>
        <BtnDeleteResource
          :resource="item"
          no-text
          :dialogHeader="'Delete contract'|pgettext('Contract/DialogTitle')"
          class="mr-2"
          @success="evh_9004123373732307_success($event, {})"
        >
        </BtnDeleteResource>
        <UcContractRevisionDropdown
          :contract="item"
        >
        </UcContractRevisionDropdown>
      </ItpBox>
      <b-tab
        :title="'General'|gettext"
        class="container float-left"
      >
        <ItpRow
          v-if="tabManager.visited(0)"
        >
          <ItpCol
            w="6"
          >
            <UcContractGeneralInfo
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_2679161326024595_reload($event, {})"
            >
            </UcContractGeneralInfo>
            <UcContractServices
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_7987652045662005_reload($event, {})"
            >
            </UcContractServices>
            <UcContractEvents
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_6490121676898844_reload($event, {})"
            >
            </UcContractEvents>
          </ItpCol>
          <ItpCol
            w="6"
          >
            <UcContractLifecycle
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_2789477278097085_reload($event, {})"
            >
            </UcContractLifecycle>
            <UcContractInvoicing
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_6182083303232630_reload($event, {})"
            >
            </UcContractInvoicing>
            <UcContractTerms
              :contract="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_5361955607147334_reload($event, {})"
            >
            </UcContractTerms>
            <UcCommentsList
              :parentId="item.revision_id"
              :parent="item"
              :reload="lastLoaded"
              class="pb-5"
            >
            </UcCommentsList>
            <UcAttachmentsList
              :parent_id="item.revision_id"
              :parent="item"
              :reload="lastLoaded"
              :readonly="readonly"
              class="pb-5"
              @reload="evh_384677887161204_reload($event, {})"
            >
            </UcAttachmentsList>
          </ItpCol>
        </ItpRow>
      </b-tab>
      <b-tab
        :title="'Billing list'|pgettext('Contract')"
        class="container-fluid h-100"
      >
        <UcBillingList
          :contractId="item.id"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(1)"
        >
        </UcBillingList>
      </b-tab>
      <b-tab
        :title="'Invoices'|pgettext('Contract')"
        class="container-fluid h-100"
      >
        <InvoiceLinesView
          :contractId="item.id"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(2)"
        >
        </InvoiceLinesView>
      </b-tab>
    </MaterialTabs>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "contract",
    path: "/contracts/:id",
    component: "Contract",
    params: [{
      name: "id",
      prop: "contractId",
    }
      ,
    {
      name: "rev",
      prop: "revision_number",
    }
      ,
    ]

  }
)

@Component()
export default class Contract extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  contractId!: string;

  @Watch('contractId')
  onContract_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contractId")
  }

  @Prop({
    type: String,
  })
  revision_number!: string;

  @Watch('revision_number')
  onRevision_number(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("revision_number")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  tabManager!: any;

  async $$load_tabManager() {
    return new this.$app.utils.LazyTabManager()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_contract', { asResource: true, parameters: { id: this.contractId, rev: this.revision_number } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2285343489561581_to!: any;
  dataMembers = ['tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        tabManager: null,
        item: null,
        ux: {
          initialLoadSpinner: true,
        }
        ,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2285343489561581_to: {
          name: "app.contracts",
        }
        ,
      },
    }
  }

  get readonly() {
    if (this.loaded) {

      return this.item.locked
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.item.snapshot('contract_number')
          ,
        this.$fn.gettext("Contract")
          ,
        ]
        ,
        icon: this.$config.contract.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3896_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3896, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2095089031469157_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_9004123373732307_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
  }

  async evh_2679161326024595_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
  }

  async evh_7987652045662005_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7987652045662005_reload.executeFromDOM(this, event, scope);
  }

  async evh_6490121676898844_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6490121676898844_reload.executeFromDOM(this, event, scope);
  }

  async evh_2789477278097085_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2789477278097085_reload.executeFromDOM(this, event, scope);
  }

  async evh_6182083303232630_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6182083303232630_reload.executeFromDOM(this, event, scope);
  }

  async evh_5361955607147334_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5361955607147334_reload.executeFromDOM(this, event, scope);
  }

  async evh_384677887161204_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_384677887161204_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3896: actions.CloseModalAction;
    evh_7315092382398562_close_3895: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2095089031469157_reloadComponentData_3898: actions.ReloadComponentDataAction;
    evh_2095089031469157_clickPreventStop_3897: actions.EventHandlerImpl;
    evh_2095089031469157_clickPreventStop: actions.EventHandlerGroup;
    act_9004123373732307_closeComponent_3900: actions.CloseComponentAction;
    evh_9004123373732307_success_3899: actions.EventHandlerImpl;
    evh_9004123373732307_success: actions.EventHandlerGroup;
    act_2679161326024595_reloadComponentData_3902: actions.ReloadComponentDataAction;
    evh_2679161326024595_reload_3901: actions.EventHandlerImpl;
    evh_2679161326024595_reload: actions.EventHandlerGroup;
    act_7987652045662005_reloadComponentData_3904: actions.ReloadComponentDataAction;
    evh_7987652045662005_reload_3903: actions.EventHandlerImpl;
    evh_7987652045662005_reload: actions.EventHandlerGroup;
    act_6490121676898844_reloadComponentData_3906: actions.ReloadComponentDataAction;
    evh_6490121676898844_reload_3905: actions.EventHandlerImpl;
    evh_6490121676898844_reload: actions.EventHandlerGroup;
    act_2789477278097085_reloadComponentData_3908: actions.ReloadComponentDataAction;
    evh_2789477278097085_reload_3907: actions.EventHandlerImpl;
    evh_2789477278097085_reload: actions.EventHandlerGroup;
    act_6182083303232630_reloadComponentData_3910: actions.ReloadComponentDataAction;
    evh_6182083303232630_reload_3909: actions.EventHandlerImpl;
    evh_6182083303232630_reload: actions.EventHandlerGroup;
    act_5361955607147334_reloadComponentData_3912: actions.ReloadComponentDataAction;
    evh_5361955607147334_reload_3911: actions.EventHandlerImpl;
    evh_5361955607147334_reload: actions.EventHandlerGroup;
    act_384677887161204_reloadComponentData_3914: actions.ReloadComponentDataAction;
    evh_384677887161204_reload_3913: actions.EventHandlerImpl;
    evh_384677887161204_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3896 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3896_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3895 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3896,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3895],
      }
    );
    const act_2095089031469157_reloadComponentData_3898 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_2095089031469157_clickPreventStop_3897 = new actions.EventHandlerImpl(
      {
        action: act_2095089031469157_reloadComponentData_3898,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2095089031469157_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2095089031469157_clickPreventStop_3897],
      }
    );
    const act_9004123373732307_closeComponent_3900 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_9004123373732307_success_3899 = new actions.EventHandlerImpl(
      {
        action: act_9004123373732307_closeComponent_3900,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const evh_9004123373732307_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_9004123373732307_success_3899],
      }
    );
    const act_2679161326024595_reloadComponentData_3902 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2679161326024595_reload_3901 = new actions.EventHandlerImpl(
      {
        action: act_2679161326024595_reloadComponentData_3902,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2679161326024595_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2679161326024595_reload_3901],
      }
    );
    const act_7987652045662005_reloadComponentData_3904 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7987652045662005_reload_3903 = new actions.EventHandlerImpl(
      {
        action: act_7987652045662005_reloadComponentData_3904,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7987652045662005_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7987652045662005_reload_3903],
      }
    );
    const act_6490121676898844_reloadComponentData_3906 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6490121676898844_reload_3905 = new actions.EventHandlerImpl(
      {
        action: act_6490121676898844_reloadComponentData_3906,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_6490121676898844_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_6490121676898844_reload_3905],
      }
    );
    const act_2789477278097085_reloadComponentData_3908 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2789477278097085_reload_3907 = new actions.EventHandlerImpl(
      {
        action: act_2789477278097085_reloadComponentData_3908,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2789477278097085_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2789477278097085_reload_3907],
      }
    );
    const act_6182083303232630_reloadComponentData_3910 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6182083303232630_reload_3909 = new actions.EventHandlerImpl(
      {
        action: act_6182083303232630_reloadComponentData_3910,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_6182083303232630_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_6182083303232630_reload_3909],
      }
    );
    const act_5361955607147334_reloadComponentData_3912 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5361955607147334_reload_3911 = new actions.EventHandlerImpl(
      {
        action: act_5361955607147334_reloadComponentData_3912,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5361955607147334_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5361955607147334_reload_3911],
      }
    );
    const act_384677887161204_reloadComponentData_3914 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_384677887161204_reload_3913 = new actions.EventHandlerImpl(
      {
        action: act_384677887161204_reloadComponentData_3914,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_384677887161204_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_384677887161204_reload_3913],
      }
    );
    return {
      act_7315092382398562_closeModal_3896,
      evh_7315092382398562_close_3895,
      evh_7315092382398562_close,
      act_2095089031469157_reloadComponentData_3898,
      evh_2095089031469157_clickPreventStop_3897,
      evh_2095089031469157_clickPreventStop,
      act_9004123373732307_closeComponent_3900,
      evh_9004123373732307_success_3899,
      evh_9004123373732307_success,
      act_2679161326024595_reloadComponentData_3902,
      evh_2679161326024595_reload_3901,
      evh_2679161326024595_reload,
      act_7987652045662005_reloadComponentData_3904,
      evh_7987652045662005_reload_3903,
      evh_7987652045662005_reload,
      act_6490121676898844_reloadComponentData_3906,
      evh_6490121676898844_reload_3905,
      evh_6490121676898844_reload,
      act_2789477278097085_reloadComponentData_3908,
      evh_2789477278097085_reload_3907,
      evh_2789477278097085_reload,
      act_6182083303232630_reloadComponentData_3910,
      evh_6182083303232630_reload_3909,
      evh_6182083303232630_reload,
      act_5361955607147334_reloadComponentData_3912,
      evh_5361955607147334_reload_3911,
      evh_5361955607147334_reload,
      act_384677887161204_reloadComponentData_3914,
      evh_384677887161204_reload_3913,
      evh_384677887161204_reload,
      reload: act_2095089031469157_reloadComponentData_3898,
    }
  }
}

Vue.component("Contract", Contract);

</script>